import { observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { updateSearch } from 'bernie-core';

import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { LoyaltyMessagingModel } from 'models';

import { Level, liveAnnounce } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkSwitch } from 'uitk-react-switch';
import { UitkText } from 'uitk-react-text';

export interface LoyaltyMessagingProps extends LocalizedComponentProps, RouteComponentProps {
  model: LoyaltyMessagingModel;
  searchCriteria?: SearchCriteriaModel;
  forceHistoryPushOnGoBack?: () => void;
}

const ToggleSwitchTracked = ClickTracker(UitkSwitch);

// @ts-ignore
@withLocalization
@observer
class SWPToggleComponent extends React.Component<LoyaltyMessagingProps> {
  private handleClick = () => {
    const { searchCriteria, forceHistoryPushOnGoBack, history, location, l10n } = this.props;
    updateSearch({ history, location, newParams: { useRewards: String(searchCriteria?.useRewards !== 'true') }, replace: true });

    if (forceHistoryPushOnGoBack && typeof forceHistoryPushOnGoBack === 'function') {
      forceHistoryPushOnGoBack();
    }

    if (searchCriteria?.useRewards === 'true') {
      setTimeout(() => liveAnnounce(l10n.formatText('common.pointsRemoved'), Level.POLITE), 500);
    } else {
      setTimeout(() => liveAnnounce(l10n.formatText('common.pointsApplied'), Level.POLITE), 500);
    }
  };

  public render() {
    const { model, searchCriteria } = this.props;

    if (!model || !model.saveWithPointsActionMessage || !model.saveWithPointsMessage || !searchCriteria) {
      return null;
    }

    return (
      <UitkSpacing padding={{ block: 'two' }}>
        <div data-stid="swp-toggle">
          <UitkText size={300}>
            <ToggleSwitchTracked
              id="swpToggle"
              checked={searchCriteria.useRewards === 'true'}
              onChange={this.handleClick}
              rfrr={`swpToggle: ${model.saveWithPointsActionMessage}`}
              linkName={'rewards toggle'}
            >
              {model.saveWithPointsMessage}
            </ToggleSwitchTracked>
          </UitkText>
        </div>
      </UitkSpacing>
    );
  }
}

export const SWPToggle = withRouter(SWPToggleComponent);
